import { storyblokEditable } from "@storyblok/react";
import classNames from "classnames";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { usePathname } from "@lib/i18n/navigation-app-router";
import { useCurrentUser } from "@hooks/use-current-user";
import { useCloseNavSearch } from "@hooks/use-nav-search-hooks";
import Link from "@components/core/LinkApp";
import { storyblokImage } from "@utils/images/storyblokImage";

// The banner is at most ~600px wide in the nav search panel.
const BANNER_IMAGE_WIDTH = 1200;

function NavsearchBanner({ blok }) {
  const pathname = usePathname();
  const user = useCurrentUser();
  const userGroup = user?.user_group || "visitor";
  const closeNavSearch = useCloseNavSearch();

  const backgroundStyle = blok?.background_image?.filename && {
    backgroundImage: `url("${storyblokImage(blok.background_image.filename, { width: BANNER_IMAGE_WIDTH })}")`,
  };

  function sendLinkTrackerData() {
    const defaultEventData = {
      page: pathname,
      tracking_name: "navsearchBanner",
      link: blok.link?.url,
      user_group: userGroup,
    };

    ahoy("$click", defaultEventData);
    analytics.track("$click", defaultEventData);
  }

  function handleClick() {
    sendLinkTrackerData();
    closeNavSearch();
  }

  if (!blok) return null;

  return (
    <section className="p-3 bg-lighter-gray">
      <Link
        href={blok.link?.url}
        prefetch={false}
        key={blok._uid}
        onClick={handleClick}
        {...storyblokEditable(blok)}
      >
        <div
          className={classNames(
            blok.background_image?.filename && "navsearch-banner-background-image",
            "navsearch-banner-container",
          )}
          style={backgroundStyle}
        />
      </Link>
    </section>
  );
}

export default NavsearchBanner;
